import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import SubmissionsPage from './components/SubmissionsPage';
import SubmissionDetailsPage from './components/SubmissionDetailsPage';
import UserManagementPage from './components/admin/UserManagementPage';
import DeviceManagementPage from "./components/admin/DeviceManagementPage";
import AgencyManagementPage from "./components/admin/AgencyManagementPage";
import LicenseManagementPage from "./components/admin/LicenseManagementPage";
import EnvironmentConfigPage from "./components/admin/EnvironmentConfigPage";
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { OriProvider } from './context/OriContext';
import LoadingIcon from './components/LoadingIcon';
import AdminRoute from './components/admin/AdminRoute';
import MainLayout from "./components/MainLayout";

export const getEnvironmentDAI = (): string => {
    return process.env.REACT_APP_DAI || '';
}

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <LoadingIcon />
        </div>
    );
  }

  return isAuthenticated ? (
    <OriProvider>
      <Outlet />
    </OriProvider>
  ) : <Navigate to="/login" />;
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <LoginPage />} />
      <Route element={<ProtectedRoute />}>{/* This is the layout for authenticated users */}
        <Route element={<MainLayout />}>
        <Route path="/submissions" element={<SubmissionsPage />} />
        <Route path="/submissions/:tcn" element={<SubmissionDetailsPage />} />
        <Route path="/" element={<HomePage />} />
        <Route element={<AdminRoute />}>
          <Route path="/devices" element={<DeviceManagementPage />} />
          <Route path="/users" element={<UserManagementPage />} />
          <Route path="/agencies" element={<AgencyManagementPage />} />
          <Route path="/licensing" element={<LicenseManagementPage />} />
          <Route path="/environment" element={<EnvironmentConfigPage />} />
        </Route>
      </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
